import React from 'react';
import ResetButtonComponent from './component';

const ResetButtonContainer = props => <ResetButtonComponent {...props} />;

export default ResetButtonContainer
